// extracted by mini-css-extract-plugin
module.exports = {"root":"b1ddd01198--root--jWXTx","amenity-list":"b1ddd01198--amenity-list--fGgEd","amenity-no":"b1ddd01198--amenity-no--CAmOP","amenity-yes":"b1ddd01198--amenity-yes--GKhvG"};